import { createContext } from "react";

export const DEFAULT_LINK_TEXT = "Visit Website";
export const TRUSTPILOT_REVIEW_WIDGET = "tp";
export const WEB_REVIEW_WIDGET = "web";

export const ThemeContext = createContext({
	reviewWidget: null,
	linkText: DEFAULT_LINK_TEXT,
	rendersCoupon: false,
	rendersPhoneLink: false,
});
